import React from 'react'
import './Badget.css'

export default function Badget({Icon, bold_text, regular_text}) {
  return (
    <div className='Badget'>
        <Icon className="BadgetIcon" />
        <div style={{marginLeft:"5px"}}>{regular_text}</div>
        <strong style={{marginLeft:"5px"}}>{bold_text}</strong>
    </div>
  )
}


